import {
  SYNC_TEAMS
} from '../actions/types';

//todo paginate this
const DEFAULT_STATE = {
  data: [],
  loading: false,
  error: null
}

export default function(state = DEFAULT_STATE, action){
  switch(action.type){
    case SYNC_TEAMS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      }
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/teamsReducer.js